import { render, staticRenderFns } from "./ProductBack.vue?vue&type=template&id=45b666cc&scoped=true&"
import script from "./ProductBack.vue?vue&type=script&lang=js&"
export * from "./ProductBack.vue?vue&type=script&lang=js&"
import style0 from "./ProductBack.vue?vue&type=style&index=0&id=45b666cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b666cc",
  null
  
)

export default component.exports